import React, { useCallback } from 'react';

import Space from 'components/generic/Space.component';
import CurrencySign from 'components/price/CurrencySign.component';
import DEPOSIT_SOURCE from 'constants/payment/depositSource.const';
import { useTranslation } from 'providers/GILT.provider';
import pageScrollToTop from 'utils/dom/pageScrollToTop.util';
import call from 'utils/functions/call.util';

import ConfirmationDialog from 'scheduler/components/ConfirmationDialog';

const LockedRefundDialog = ({ value, source, onClose, onConfirm }) => {
  const { t } = useTranslation();

  const handleConfirm = useCallback(() => {
    call('LockedRefundDialog.onConfirm', onConfirm);
    call('LockedRefundDialog.onClose', onClose);
    pageScrollToTop();
  }, [onConfirm, onClose]);

  pageScrollToTop();

  return (
    <ConfirmationDialog
      onRequestClose={onClose}
      onLeft={onClose}
      onCancel={onClose}
      onRight={handleConfirm}
      title={t('balanceSheet.refundDialog.title')}
      leftButtonText={t('common.buttons.cancel')}
      rightButtonText={t('common.buttons.confirm')}
    >
      <p className="dark-text m-b-20">
        {t('balanceSheet.refundDialog.descriptionPart1')}
        <span className="text-bold">
          <Space>
            <CurrencySign value={value} />
          </Space>
        </span>
        {source === DEPOSIT_SOURCE.card && t('balanceSheet.refundDialog.descriptionPart2')}
        {(source === DEPOSIT_SOURCE.cash || source === DEPOSIT_SOURCE.online) &&
          t('balanceSheet.refundDialog.descriptionPart3')}
        {source === DEPOSIT_SOURCE.other && t('balanceSheet.refundDialog.descriptionPart4')}
      </p>
      <p className="dark-text">{t('balanceSheet.refundDialog.guideText')}</p>
    </ConfirmationDialog>
  );
};

export default LockedRefundDialog;
